// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3dma3","head":"Table_head__1rRR5","col":"Table_col__qm2UE"};